/**
 * Agent Chat ```flow 펜스(v2) -> 공용 흐름도(components/flo) 의미 그래프 변환.
 *
 * 펜스는 대화 이력에 저장되므로 짧은 키와 배열 색인으로 적혀 있다(서버 infra/flow_graph.py).
 * 공용 컴포넌트는 이름 붙은 필드의 의미 그래프를 받으므로 여기서 한 번 풀어 준다.
 * 노드 key 는 펜스 색인, rank 도 펜스 색인이다 — 펜스 순서가 같은 칸의 동률 순서라서다.
 * 순수 함수만 둔다.
 */

// 이 버전의 펜스만 읽는다 —
//   낮은 버전은 좌표가 박힌 옛 모양이라 읽지 않고, 높은 버전은 새로고침 안내를 낸다.
export const FLOW_FENCE_VERSION = 2;

/** 펜스 스펙(JSON 파싱 결과)을 의미 그래프로 바꾼다. */
export function fenceToGraph(spec) {
  const lanes = (spec?.lanes || []).map((ln) => ({
    key: ln.code, name: ln.label, code: ln.code, ...(ln.type ? { type: ln.type } : {}),
  }));
  const rawNodes = spec?.nodes || [];
  const nodes = rawNodes.map((n, i) => {
    const g = { key: String(i), rank: i, kind: n.t, lane: lanes[n.l]?.key, name: n.label };
    if (n.sub) g.sub = n.sub;
    if (n.code) g.code = n.code;
    if (n.root) g.root = true;
    if (n.pur) g.purchased = true;
    if (n.x) g.more = true;
    if (n.sup) g.supply = n.sup;
    if (n.g && n.g.length) g.warnings = [...n.g];
    if (n.tip && n.tip.length) g.tip = [...n.tip];
    if (n.res) {
      g.resource = { name: n.res.label, count: n.res.n };
      if (n.res.tip && n.res.tip.length) g.resource.tip = [...n.res.tip];
    }
    return g;
  });
  const edges = (spec?.edges || []).map((e) => {
    const s = rawNodes[e.s] || {};
    const t = rawNodes[e.t] || {};
    // 종류는 두 끝이 모두 재고일 때(되돌이)만 펜스에 실린다 — 그 밖에는 공정 쪽 끝의 종류다.
    const kind = e.k || (s.t && s.t !== "inv" ? s.t : t.t);
    const g = { from: String(e.s), to: String(e.t), kind };
    if (e.q != null) g.qty = e.q;
    if (e.r != null) g.ratio = e.r;
    if (e.back) g.back = true;
    return g;
  });
  return { dir: spec?.dir, lanes, nodes, edges };
}
